import './entry-group-step4.scss'

import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { get_quote_group_data } from 'src/containers/data-entry/handlers/data-entry-quote-group'
import { usePrice } from 'src/containers/data-entry/handlers/price.hook'
import { SAGA_GUARDS } from 'src/navigation'
import { shoot } from 'src/redux/actions'
import { select_error, select_history_item, select_loading, select_quote } from 'src/redux/store'
import { agency_product_t, coverage_t, coverages_t } from 'src/types'
import { Formik, FormikMainInsured } from 'src/types/formik'
import { FormikMainInsuredGroup } from 'src/types/formik/group.types'
import { quote_t } from 'src/types/http/quote.types'
import { getDifferenceInDays } from 'src/utils'

export const useEntryGroupStep4 = ({
  formikFather,
  formikMainInsured,
  discountError = '',
  setDiscountError,
}: {
  formikFather: Formik<FormikMainInsuredGroup>
  formikMainInsured: FormikMainInsured
  discountError?: string
  setDiscountError: Dispatch<SetStateAction<string>>
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();

  const values = formikMainInsured;
  const { mainInsured } = formikFather?.values ?? {}

  // Constants
  const isMultiDays =
    getDifferenceInDays(
      formikMainInsured.coverage_start_date,
      formikMainInsured.coverage_end_date
    ) + 1 >= 3

  const price = usePrice(discountError, ' ')

  // Selectors
  const historyCoverages: coverages_t = useSelector(select_history_item("history_coverages"));
  const historyAgency = useSelector(select_history_item("history_agency"));
  const historyCoverage = historyCoverages?.[formikMainInsured.coverage_type_radios || ''];
  const loading = useSelector(select_loading(SAGA_GUARDS.QUOTE));
  const loadingQuote = useSelector(select_loading(SAGA_GUARDS.QUOTE));
  const quote = useSelector(select_quote);
  const error = useSelector(select_error());
  const agency: agency_product_t = useSelector(select_history_item("history_agency"));

  // States
  const [coverage] = useState<coverage_t>();
  const [policyCode, setPolicyCode] = useState(coverage?.policyCode || '')

  ////////////////////////////////////////////////////////////////////////////////////////////

  // UseEffect
  useEffect(() => {
    if (historyAgency?.isCustomNow) {
      if (formikMainInsured.coverage_type_radios === '1') {
        setPolicyCode(historyAgency?.policyNumberBase || '')
      } else if (formikMainInsured.coverage_type_radios === '2') {
        setPolicyCode(historyAgency?.policyNumberPlus || '')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    doPostQuote()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mainInsured?.discount === '') {
      setDiscountError('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainInsured?.discount])

  useEffect(() => {
    if (error) {
      const code = error?.code || ''
      const desc = error?.description_fe || ''
      if (code) {
        setDiscountError(desc)
      }
    }
  })

  ////////////////////////////////////////////////////////////////////////////////////////////

  // Functions
  const doPostQuote = () => {
    const data_: quote_t = get_quote_group_data(
      formikFather?.values?.group,
      formikFather?.values?.mainInsured,
      formikMainInsured,
      agency,
      quote?.quoteId
    );
    dispatch(shoot.saga_quote(data_));
  }

  const uppercaseDiscountValue = (props: any) => {
    let _props = props;
    _props["value"] = props["value"].toString().toUpperCase();
    return _props;
  };

  const updateTotalQuote = () => {
    const data_: quote_t = get_quote_group_data(
      formikFather?.values?.group,
      formikFather?.values?.mainInsured,
      formikMainInsured,
      agency,
      quote?.quoteId
    );
    setDiscountError("");
    dispatch(shoot.reduce_error());
    dispatch(shoot.saga_quote(data_));
  }

  return {
    t,
    quote,
    price,
    agency: historyAgency,
    quoting: loadingQuote,
    coverage: historyCoverage,
    loading,
    values,
    coverages: historyCoverages,
    policyCode,
    isMultiDays,
    updateTotalQuote,
    uppercaseDiscountValue,
  }
}
